import { PageBlock } from '@design-system/page-block';
import React, { forwardRef } from 'react';

import BodyRender from '~/components/BodyRender';

import { ImageTextBlockProps } from './models';

const ImageTextBlock = forwardRef<HTMLDivElement, ImageTextBlockProps>(
  ({ pageBlock, componentId, items, currentPageUid }, ref) => (
    <PageBlock
      {...pageBlock}
      id={componentId}
      className="image-text-block"
      ref={ref}
    >
      <BodyRender items={items} currentPageUid={currentPageUid} />
    </PageBlock>
  )
);

export default ImageTextBlock;
